import React from 'react';
import { Container } from 'react-bootstrap';
import '../styles/brand.css';

const TermsOfService = () => (
  <main className="policy-page">
    <Container>
      <section className="policy-card">
        <p className="policy-kicker">Access70 LMS</p>
        <h1>Terms of Service</h1>
        <p className="policy-updated">Last updated: 19 June 2026</p>

        <h2>1. Purpose</h2>
        <p>
          Access70 LMS is provided by NPI Governance Solutions to support workplace readiness programmes, learner administration,
          attendance, resources, assessments, communications, reporting, and compliance activities.
        </p>

        <h2>2. User Responsibilities</h2>
        <p>
          Users must provide accurate information, keep login details secure, use the platform only for authorised programme
          activities, and avoid uploading unlawful, harmful, misleading, or irrelevant content.
        </p>

        <h2>3. Platform Access</h2>
        <p>
          Access is role based. Learners, facilitators, assessors, QA users, external users, and administrators may see different
          features depending on their assigned permissions and programme responsibilities.
        </p>

        <h2>4. Uploaded Content</h2>
        <p>
          Documents, submissions, resources, attendance records, and messages uploaded to the platform may be reviewed by authorised
          NPI staff or appointed programme representatives for administration, assessment, reporting, and compliance purposes.
        </p>

        <h2>5. Availability</h2>
        <p>
          NPI aims to keep the platform available and reliable, but access may be interrupted by maintenance, connectivity issues,
          third-party service disruption, or security controls.
        </p>

        <h2>6. Acceptable Use</h2>
        <p>
          Users may not attempt to bypass permissions, access another user's account, interfere with system operation, distribute
          malicious files, or use platform data outside approved programme and reporting purposes.
        </p>

        <h2>7. Changes</h2>
        <p>
          NPI may update these terms as the system, programme requirements, or regulatory obligations change. Continued use of the
          platform means the updated terms apply.
        </p>
      </section>
    </Container>
  </main>
);

export default TermsOfService;
